export default __webpack_public_path__ + "static/media/Favorite-default.9cca9054.svg";